var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69362",
    "data-name": "Group 69362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.941,
    height: 143.954,
    viewBox: "0 0 150.941 143.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141853",
    "data-name": "Rectangle 141853",
    width: 150.941,
    height: 143.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86074",
    "data-name": "Path 86074",
    d: "M65.139,58.036c-1.392,1.034-41.585,1.832-44.993,11.817s28.219,34.577,28.763,36.674-9.54,40.538-1.991,45.719c4.194,2.88,16.436-2.224,26.857-7.328,8.338-4.083,15.51-8.167,16.461-8.161,2.137.012,37.186,20.567,43.317,15.489s-2.025-44.568-1.286-46.423,31.274-28.43,28.058-35.971-42.688-10.82-44.287-11.817-15.33-39.106-25.8-39.106S66.531,57,65.139,58.036",
    transform: "translate(-19.889 -18.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 0.849,
    x2: 0.127,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#ffeb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ffd54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc943"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141851",
    "data-name": "Rectangle 141851",
    width: 78.182,
    height: 16.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141849",
    "data-name": "Rectangle 141849",
    width: 18.118,
    height: 16.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141850",
    "data-name": "Rectangle 141850",
    width: 18.119,
    height: 16.728,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69361",
    "data-name": "Group 69361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69347",
    "data-name": "Group 69347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69346",
    "data-name": "Group 69346",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86073",
    "data-name": "Path 86073",
    d: "M75.484,0c11.236,0,26.723,39.375,28.438,40.443s43.309,6.1,46.758,14.19S122.127,91.99,121.334,93.981s7.2,43.6.625,49.052S77.777,127.182,75.484,127.17,37.108,148.592,29.01,143.033s1.208-46.8.626-49.052S-3.369,65.345.287,54.633s45.267-13.08,46.76-14.19S64.25,0,75.484,0",
    transform: "translate(0)",
    fill: "#ffbd39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69349",
    "data-name": "Group 69349",
    transform: "translate(5.137 4.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69348",
    "data-name": "Group 69348",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141848",
    "data-name": "Rectangle 141848",
    width: 201.369,
    height: 200.286,
    transform: "matrix(0.769, -0.64, 0.64, 0.769, -71.201, 56.65)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69360",
    "data-name": "Group 69360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69359",
    "data-name": "Group 69359",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86075",
    "data-name": "Path 86075",
    d: "M56.322,201.537c-.728-7.1,22.564-11.279,23.593-2.971s-22.6,12.644-23.593,2.971",
    transform: "translate(-41.763 -143.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86076",
    "data-name": "Path 86076",
    d: "M170.8,192.123c-.174-4.567,6.789-4.845,7.153-1.1.4,4.195-6.991,5.37-7.153,1.1",
    transform: "translate(-126.684 -139.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69358",
    "data-name": "Group 69358",
    transform: "translate(32.804 84.064)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69357",
    "data-name": "Group 69357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69356",
    "data-name": "Group 69356",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69352",
    "data-name": "Group 69352",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69351",
    "data-name": "Group 69351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69350",
    "data-name": "Group 69350",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86077",
    "data-name": "Path 86077",
    d: "M145.135,333.853c0,4.618-4.056,8.364-9.06,8.364s-9.059-3.746-9.059-8.364,4.056-8.363,9.059-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-127.017 -325.49)",
    fill: "#ff5f82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69355",
    "data-name": "Group 69355",
    transform: "translate(60.063)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69354",
    "data-name": "Group 69354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69353",
    "data-name": "Group 69353",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86078",
    "data-name": "Path 86078",
    d: "M377.7,333.853c0,4.618-4.056,8.364-9.059,8.364s-9.061-3.746-9.061-8.364,4.057-8.363,9.061-8.363,9.059,3.744,9.059,8.363",
    transform: "translate(-359.577 -325.49)",
    fill: "#ff5f82"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_86079",
    "data-name": "Path 86079",
    d: "M190.286,224.52c-11.61,1.089-8.46,25.064.869,24.609s10.742-25.7-.869-24.609",
    transform: "translate(-135.586 -166.508)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86080",
    "data-name": "Path 86080",
    d: "M220.99,266.4c-2.472-.319-3.255,5.57-.457,6.2s3.963-5.75.457-6.2",
    transform: "translate(-162.26 -197.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86081",
    "data-name": "Path 86081",
    d: "M348.834,224.52c11.612,1.089,8.461,25.064-.867,24.609s-10.742-25.7.867-24.609",
    transform: "translate(-252.595 -166.508)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86082",
    "data-name": "Path 86082",
    d: "M350.794,266.4c2.47-.319,3.255,5.57.457,6.2s-3.965-5.75-.457-6.2",
    transform: "translate(-258.582 -197.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86083",
    "data-name": "Path 86083",
    d: "M196.675,161.293c1.06-2.21-3.621-5.657-9.71-4.374-4.117.866-8.014,5.967-7.008,7.1s2.587-2.546,7.923-3.488c4.578-.808,8.339,1.715,8.8.761",
    transform: "translate(-133.361 -116.185)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86084",
    "data-name": "Path 86084",
    d: "M338.855,161.293c-1.06-2.21,3.619-5.657,9.71-4.374,4.117.866,8.014,5.967,7.008,7.1s-2.587-2.546-7.922-3.488c-4.582-.808-8.34,1.715-8.8.761",
    transform: "translate(-251.228 -116.185)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86085",
    "data-name": "Path 86085",
    d: "M266.6,394.8c-2.455,1.854-22.316,1.849-24.79,0-1.706-1.272-2.231-7.566,12.387-7.566s14.084,6.294,12.4,7.566",
    transform: "translate(-178.73 -287.221)",
    fill: "#872a2a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating2);
export default __webpack_public_path__ + "static/media/rating-2.89aa0c97c53f9c630571ef5d89a7de6b.svg";
export { ForwardRef as ReactComponent };